module.exports = ".version {\r\n  text-align: center;\r\n  color: #e9e9e9;\r\n  text-decoration: none;\r\n  font-size: 10px;\r\n  position: absolute;\r\n  bottom: 0;\r\n  height: 15px;\r\n  width: 100%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/sidebar.component.css
// module id = ./src/app/sidebar/sidebar.component.css
// module chunks = main